module.exports = __webpack_public_path__ + "static/img/s201.d503dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s201.png
// module id = 543
// module chunks = 3